import firebase from 'firebase/app'
import 'firebase/firestore'

const firebaseConfig = {
  apiKey: 'AIzaSyBbwsQt2_jMXxdKp0gpf7tecrrPso2cBVU',
  authDomain: 'backstage-web-e5597.firebaseapp.com',
  projectId: 'backstage-web-e5597',
  storageBucket: 'backstage-web-e5597.appspot.com',
  messagingSenderId: '916829891212',
  appId: '1:916829891212:web:64cb5ca9fcaf72819869a9',
  measurementId: 'G-KY6BJNNC9Q',
}
firebase.initializeApp(firebaseConfig)

const db = firebase.firestore()
export { db, firebase }



//////////////////
// WEBPACK FOOTER
// ./config/firebase_config.js
// module id = null
// module chunks = 